<template>
  <div>
    <div class="instInputWrap">
      <div class="instInputPosition">
        <input
          :id="'finstSbp'"
          v-model.trim="value"
          v-on:blur="eventBlur"
          v-on:focus="eventFocus"
          autocomplete="off"
        >
        <label :for="'finstSbp'" v-bind:class="{active:value.length > 0 || inFocus}">
          <img src="@/assets/vector/finder.svg" svg-inline>
          <p>Название банка</p>
        </label>
      </div>
    </div>
    <div v-for="(item,index) in bankListComputed" :key="index" class="item">
      <label :for="'bank_'+index" class="instRadioInput">
        <div class="fakeWrap" v-bind:class="{active: tinkoffA2C_bankSelected.memberId === item.memberId}">
          <input type="radio" v-model="tinkoffA2C_bankSelected" :value="item" :id="'bank_'+index">
        </div>
        <img :src="issetSVG(item.memberId)" alt="" v-if="issetSVG(item.memberId)">
        <span>{{ item.memberNameRus }}</span>
      </label>
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  name: "instSbp",
  data() {
    return {
      bankList: [],
      inFocus: false,
      value: '',
      bankIcons: {
        100000000111: require('@/assets/vector/circleSber.svg'),
        100000000008: require('@/assets/vector/circleAlfa.svg'),
        100000000005: require('@/assets/vector/circleVtb.svg'),
        100000000010: require('@/assets/vector/circlePsb.svg'),
        100000000004: require('@/assets/vector/circleTbank.svg'),
      },
    }
  },
  methods: {
    issetSVG(memberId){
      return this.bankIcons[memberId] !== undefined ? this.bankIcons[memberId] : '';
    },
    eventBlur() {
      this.inFocus = false;
    },
    eventFocus() {
      this.inFocus = true;
    },
    getTinkoffA2C() {
      this.$axios({
        method: 'post',
        url: process.env.VUE_APP_URL_TINKOF,
        data: {
          action: 'get-sbp-members',
          work: true,
        }
      }).then(res => {
        let tmpBankList = res.data.members.sort((a, b) => {
          let left = a.memberNameRus.toString().toLowerCase();
          let right = b.memberNameRus.toString().toLowerCase();
          if (left < right) return -1;
          if (left > right) return 1;
          return 0
        });
        for (let i = 0; i < tmpBankList.length; i += 1) {
          tmpBankList[i]['finderStr'] = tmpBankList[i].memberName.toLowerCase() + ' ' + tmpBankList[i].memberNameRus.toLowerCase();
        }
        this.bankList = tmpBankList;
      }).catch(res => {
        console.log(res);
      })
    },
  },
  computed: {
    ...mapState({
      statusVuex:state => state.Form.workData.tinkoffA2C_bankSelected,
      valueVuex: state => state.Form.sendData.tinkoffA2C_bankSelected,
    }),
    bankListComputed() {
      let out = [];

      out = this.bankList.filter((item) => {
        return (this.value.length > 0 && item.finderStr.indexOf(this.value.toLowerCase()) >= 0)
          || this.bankIcons[item.memberId] !== undefined
      });

      return out;
    },
    tinkoffA2C_bankSelected: {
      get() {
        return this.valueVuex;
      },
      set(value) {
        this.$store.dispatch('saveSendData', {
          target: 'tinkoffA2C_bankSelected',
          value: value
        });
      }
    },
  },
  mounted() {
    this.getTinkoffA2C();
  }
}
</script>

<style scoped>
label {
  display: flex;
  align-items: center;
  justify-content: flex-start
}



.instRadioInput > img {margin-right: var(--font-size-08);width: var(--font-size-40);height: var(--font-size-40)}
</style>